import type { Partnership } from '@festina/legalentity-general-types/legalentity'
import { typeUtils, type ValidatedKey } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikSelect,
  FormikTextInput,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'
import type { PropsWithChildren } from 'react'

import { useEnumOptions } from '../../hooks/useEnumOptions'
import { useHook } from '../../lenteHooks'
import { FormikSsnInput } from '../forms/ssnInput/FormikSsnInput'

type Props = PropsWithChildren<{
  fieldNamePrefix: ValidatedKey | ''
}>

export const PartnershipFormFields = ({ fieldNamePrefix, children }: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const validateKey =
    typeUtils.createNestedValidator<Partnership>(fieldNamePrefix)
  const informationSources = useHook('pages.crm.useCrmInformationSources')()
  const partnershipTypes = useEnumOptions('PartnershipType', 'crm')
  const genderOptions = useEnumOptions('Gender', 'crm')

  return (
    <>
      <FormikDatePicker
        name={validateKey('startDate')}
        label={translate('partnership.startDate')}
      />
      <FormikDatePicker
        name={validateKey('endDate')}
        label={translate('partnership.endDate')}
      />
      <FormikSsnInput
        name={validateKey('partnerPersonId')}
        label={translate('partnership.partnerPersonId')}
      />
      <FormikTextInput
        name={validateKey('partnershipId')}
        label={translate('partnership.partnershipId')}
      />
      {/* UpdatePartnershipCommandDataForm passes children here with the informationSource select */}
      {!fieldNamePrefix && (
        <FormikSelect
          name={validateKey('informationSource')}
          label={translate('card.field.informationSource')}
          options={informationSources}
          renderFn={(x) =>
            translateEnum('legalEntity.enum.InformationSource', x)
          }
        />
      )}
      {children}
      <FormikSelect
        name={validateKey('partnershipType')}
        label={translate('partnership.partnershipType')}
        options={partnershipTypes}
        renderFn={(x) => translateEnum('legalEntity.enum.PartnershipType', x)}
      />
      <FormikTextInput
        name={validateKey('partnerName.firstName')}
        label={translate('partnership.partnerName.firstName')}
      />
      <FormikTextInput
        name={validateKey('partnerName.lastName')}
        label={translate('partnership.partnerName.lastName')}
      />
      <FormikTextInput
        name={validateKey('partnerName.initials')}
        label={translate('partnership.partnerName.initials')}
      />
      <FormikDatePicker
        name={validateKey('partnerBirthDate')}
        label={translate('partnership.partnerBirthdate')}
      />
      <FormikDatePicker
        name={validateKey('partnerDeathDate')}
        label={translate('partnership.partnerDeathDate')}
      />
      <FormikSelect
        name={validateKey('partnerGender')}
        label={translate('partnership.partnerGender')}
        options={genderOptions}
      />
    </>
  )
}
